 
// src/utils/constants.js

// src/utils/constants.js
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || ''
};

export const CHAT_CONFIG = {
  DEFAULT_WIDTH: 450,
  DEFAULT_HEIGHT: 600,
  MIN_WIDTH: 400,
  MAX_WIDTH: 800,
  MIN_HEIGHT: 400,
  MAX_HEIGHT_VH: 80
};

// `group` drives the sidebar's section headers (App.js) - 'overview' / 'operations' /
// 'monitoring' / 'settings' / 'modules'. Real, built features only; a nav item with
// nothing real behind it (previously 'ai-assistant') doesn't belong here at all rather
// than being demoted - see the sidebar-reorganization plan this was built from.
export const DEFAULT_MODULES = [
  {
    // Below-manager landing page: My schedule / My profile, or company totals for the
    // analyst (App.js shows it only below manager; managers get the dashboard).
    id: 'my-home',
    name: 'My Home',
    type: 'core',
    status: 'active',
    description: 'Your schedule, profile and site',
    group: 'overview'
  },
  {
    id: 'dashboard',
    name: 'Executive Dashboard',
    type: 'core',
    status: 'active',
    description: 'Real-time business metrics and AI insights',
    group: 'overview'
  },
  {
    id: 'financial-reports',
    name: 'Financial Reporting',
    type: 'core',
    status: 'active',
    description: 'Current snapshot and per-client revenue breakdown',
    group: 'overview'
  },
  {
    id: 'clients',
    name: 'Clients',
    type: 'core',
    status: 'active',
    description: 'Real client roster - revenue, staffing, and contract terms',
    group: 'overview'
  },
  {
    id: 'business-setup',
    name: 'AI Business Setup',
    type: 'core',
    status: 'active',
    description: 'Aetheris-powered business configuration wizard',
    group: 'overview'
    // Visibility is additionally gated in App.js on businessData.employees.length === 0 -
    // no onboarding wizard actually exists behind this yet for any business (flagged, not
    // fixed here); this only hides it once a business is clearly already onboarded.
  },
  {
    id: 'team',
    name: 'Team Management',
    type: 'core',
    status: 'active',
    description: 'Invite and manage team members',
    group: 'operations'
  },
  {
    id: 'schedule',
    name: 'Schedule',
    type: 'core',
    status: 'active',
    description: 'Your shifts and coverage',
    group: 'operations'
  },
  {
    id: 'aim',
    name: 'Actionable Items',
    type: 'core',
    status: 'active',
    description: 'What needs your attention, by domain',
    group: 'operations'
  },
  {
    id: 'security-alerts',
    name: 'Security Alerts',
    type: 'core',
    status: 'active',
    description: 'Login brute-force detection and IP ban activity',
    group: 'monitoring'
  },
  {
    // Admin-only link to the camera server's admin screen (App.js also hides it unless
    // GET /api/argus-ui says this business has one configured).
    id: 'argus',
    name: 'Argus',
    type: 'core',
    status: 'active',
    description: 'Camera server admin screen (Tailscale only)',
    group: 'monitoring'
  },
  {
    id: 'customization',
    name: 'Customization',
    type: 'core',
    status: 'active',
    description: 'Brand colors for your company dashboard',
    group: 'settings'
  },
  {
    id: 'module-library',
    name: 'Module Library',
    type: 'system',
    status: 'active',
    description: 'Real, built modules for this business - adopt or open one',
    group: 'modules'
  },
];

export const COLORS = {
  PRIMARY: '#3b82f6',
  SECONDARY: '#8b5cf6',
  SUCCESS: '#22c55e',
  WARNING: '#f59e0b',
  DANGER: '#ef4444'
};
